<template>
  <div class="video-preview">
    <video v-if="local" :src="src" controls playsinline preload="metadata" :aria-label="title" />
    <iframe v-else-if="playing && embedUrl" :src="embedUrl" :title="title"
      allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowfullscreen />
    <button v-else type="button" class="video-preview__play" :aria-label="`Reproducir ${title}`" @click="playing = true">
      <img v-if="poster" :src="poster" alt="" loading="lazy" />
      <span class="video-preview__label"><span class="video-preview__icon" aria-hidden="true">▶</span>{{ title || 'Ver video' }}</span>
    </button>
  </div>
</template>

<script setup>
import { computed, ref, watch } from 'vue';
const props = defineProps({ src: { type: String, required: true }, poster: String, title: { type: String, default: 'Ver video' } });
const playing = ref(false);
const local = computed(() => props.src.startsWith('blob:'));
const embedUrl = computed(() => /^https:\/\/(player|iframe)\.mediadelivery\.net\/embed\/\d+\/[\da-f-]{36}$/.test(props.src)
  ? `${props.src}?autoplay=true&loop=false&muted=false&preload=false&responsive=true` : '');
watch(() => props.src, () => { playing.value = false; });
</script>

<style scoped>
.video-preview { width: 100%; aspect-ratio: 16 / 9; background: #111; border-radius: 12px; overflow: hidden; position: relative; }
.video-preview video, .video-preview iframe, .video-preview__play { width: 100%; height: 100%; border: 0; display: block; }
.video-preview__play { position: relative; background: radial-gradient(ellipse at top, #38382c, #151515 75%); color: #fff; cursor: pointer; padding: 24px; }
.video-preview__play img { position: absolute; inset: 0; width: 100%; height: 100%; object-fit: cover; opacity: .5; }
.video-preview__label { position: relative; display: flex; flex-direction: column; align-items: center; gap: 12px; font-weight: 600; }
.video-preview__icon { display: grid; place-items: center; border-radius: 50%; width: 60px; height: 60px; background: var(--primary-color, #ffe000); color: #171717; font-size: 22px; padding-left: 3px; }
.video-preview__play:focus-visible { outline: 3px solid var(--primary-color, #ffe000); outline-offset: -4px; }
.video-preview__play:hover .video-preview__icon { background: #fff; }
</style>
